import SingleChoiceResponseMapper from './SingleChoice';

export default class SingleChoiceImageResponseMapper extends SingleChoiceResponseMapper {
  map(response: any) {
    return super.map(response);
  }

  unMap(response: any) {
    return super.unMap(response);
  }
}
